import { DialogTitle } from '@radix-ui/react-dialog';
import { FileQuestionMark, Copy, Check } from 'lucide-react';
import React from 'react';
import { Button } from '~/components/ui/button';
import { Card } from '~/components/ui/card';
import { Dialog, DialogContent, DialogTrigger } from '~/components/ui/dialog';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';
import { Separator } from '~/components/ui/separator';
import { convertFileToBase64 } from '~/utils/helpers';

export const FileConvertor: React.FC = () => {
  const [copied, setCopied] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [fileDataUri, setFileDataUri] = React.useState<string | null>(null);

  const handleFileConvert = async (
    event: React.InputEvent<HTMLInputElement>,
  ) => {
    const element = event.target as HTMLInputElement;
    if (!element.files || element.files.length === 0) return;
    const file = element.files[0];
    if (file) {
      setIsLoading(true);
      const dataUri = await convertFileToBase64(file);
      setFileDataUri(dataUri);
      setIsLoading(false);
    }
  };
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(fileDataUri || '');
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant='outline' size='sm'>
          <FileQuestionMark /> Convert File
        </Button>
      </DialogTrigger>
      <DialogContent className='flex flex-col gap-4'>
        <DialogTitle>File Convertor</DialogTitle>

        <Input id='picture' type='file' onInput={handleFileConvert} />

        <Card className='p-4 overflow-hidden break-all h-50 overflow-y-auto text-muted-foreground '>
          {isLoading && <span className='text-center my-auto'>Loading...</span>}
          {!isLoading && !fileDataUri && (
            <span className='text-center my-auto'>No file converted yet.</span>
          )}
          {fileDataUri}
        </Card>

        <Button
          variant='outline'
          size='sm'
          onClick={copyToClipboard}
          disabled={!fileDataUri}
        >
          {copied ? <Check /> : <Copy />}
          Copy
        </Button>
      </DialogContent>
    </Dialog>
  );
};
